
import Add from "./pages/Add";
import Home from "./pages/Home";
import Records from "./pages/Records";
import Referrers from "./pages/Referrers";
import Investor from "./pages/Investor";
import Login from "./pages/Login";
import LandingPage from "./pages/landingPage";

import Navbar from "./components/Navbar";

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import { useState, useEffect } from "react";

function App() {

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🔥 Sync with localStorage
  useEffect(() => {

    const stored = localStorage.getItem("user");

    if (stored) {
      setUser(JSON.parse(stored));
    }

    setLoading(false);

  }, []);

  if (loading) {
    return (
      <div className="p-10 text-center text-xl font-semibold">
        Loading...
      </div>
    );
  }

  return (

    <div className="relative min-h-screen">
       {/* <div
         className="fixed inset-0 bg-cover bg-center -z-10"
         style={{ backgroundImage: "url('/bg.png')" }}
       ></div> */}
      <div className="fixed inset-0 bg-white/60 -z-10"></div>

    <BrowserRouter>

      {/* NOT LOGGED IN */}
      {!user ? (

        <Routes>

          {/* Landing Page */}
          <Route
            path="/"
            element={<LandingPage />}
          />

          {/* Login */}
          <Route
            path="/login"
            element={<Login setUser={setUser} />}
          />

          {/* Redirect */}
          <Route
            path="*"
            element={<Navigate to="/" />}
          />

        </Routes>

      ) : (

        <>
          {/* Navbar only for admin */}
          {user.role === "admin" && (
            <Navbar setUser={setUser} />
          )}

          <Routes>

            {/* ADMIN ROUTES */}
            {user.role === "admin" && (
              <>
                <Route path="/home" element={<Home />} />
                <Route path="/add" element={<Add />} />
                <Route path="/records" element={<Records />} />
                <Route path="/referrers" element={<Referrers />} />
                <Route path="/investor" element={<Investor />} />

                <Route
                  path="*"
                  element={<Navigate to="/home" />}
                />
              </>
            )}

            {/* REFERRER / INVESTOR */}
            {user.role !== "admin" && (
              <>
                <Route
                  path="/dashboard"
                  element={<Records />}
                />

                <Route
                  path="*"
                  element={<Navigate to="/dashboard" />}
                />
              </>
            )}

          </Routes>
        </>
      )}

    </BrowserRouter>
    </div>
  );
}

export default App;